import LuckyDrawCreatePage from "./luckyDrawCreate.container";

export default LuckyDrawCreatePage;
